// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__28pCa","options":"AnswerScale_options__mhgjr","selected":"AnswerScale_selected__21vYx"};